import { Router } from '@reach/router';
import React, { useEffect, useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

interface IAnimatedRouter {
  children: React.ReactNode;
  className?: string;
  location: any;
  timeout?: number;
  transitionClassName?: string;
  transitionKey?: string;
  direction?: (startPath: string, endPath: string) => string;
}

const usePrevious = (value: any) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

const InnerRouter = ({
  children,
  className,
  direction,
  location,
  timeout,
  transitionClassName,
  transitionKey
}: IAnimatedRouter) => {
  const prevPath = usePrevious(location ? location.pathname : '');

  return (
    <TransitionGroup
      className={`transition-group ${className} ${
        direction ? direction(prevPath || '', location.pathname) : ''
      }`}
    >
      <CSSTransition
        key={transitionKey || location.key || location.pathname}
        classNames={transitionClassName || 'slide'}
        timeout={timeout || 750}
      >
        <Router primary={false} location={location}>
          {children && (children as any).path ? children : (children as any).props.children}
        </Router>
      </CSSTransition>
    </TransitionGroup>
  );
};

export { InnerRouter };
